import {
	InsertPhotoToGridProps,
	LoadMoreModuleInterface,
} from "./common/interfaces/common";
import { PhotoData } from "./photo/interfaces/dto";
import { ArtistData } from "./artist/interfaces/dto";
import { CategoryData } from "./categories/interfaces/dto";
import { requestLoadMore } from "./load-more/services/load-more-service";
import { buildArtistOutput } from "./load-more/utils/artist-output";
import { buildPhotoOutput } from "./load-more/utils/photo-output";
import { buildTrendingCategoriesOutput } from "./load-more/utils/trending-categories-output";
import { buildCameraOutput } from "./load-more/utils/camera-output";
import { CameraData } from "./camera/interfaces/dto";

declare var pm: PmInterface;
declare var FlexMasonry: any;

pm.module.loadMore = (function (): LoadMoreModuleInterface {
	const { findHtmlEl, findHtmlEls } = pm.utils.dom;

	const wrapper = findHtmlEl(".use-load-more");

	let ajaxController: AbortController | null = null;

	let doingAjax: boolean = false;

	let searchKeyword = "";

	let useExtraSearch = false;

	const trendingCategoriesResultWrapper = findHtmlEl(
		".trending-photo-category-list",
	);

	const $noItemsNotice = jQuery(".no-items-found");

	const elmsToHideOnSearch = findHtmlEls(".hide-on-search");

	const elmsToShowAfterSearch = findHtmlEls(".show-after-search");

	const loadingEl = findHtmlEl(".load-more-anim");

	const pageFooter = findHtmlEl(".wpbf-page-footer");

	const footerHeight = pageFooter ? pageFooter.clientHeight : 0;

	let nextPageNumber = 2;

	let currentPageNumber = nextPageNumber;

	let lastScrollTop = 0;

	let lastId =
		wrapper && wrapper.dataset.lastId
			? parseInt(wrapper.dataset.lastId, 10)
			: 0;

	let lastTotalPhotos =
		wrapper && wrapper.dataset.lastTotalPhotos
			? parseInt(wrapper.dataset.lastTotalPhotos, 10)
			: 0;

	const loadMoreType = wrapper && wrapper.dataset.loadMoreType;

	let gridItemToClone: HTMLElement | null;

	switch (loadMoreType) {
		case "photo":
			gridItemToClone = findHtmlEl(".elms-to-clone .grid-item");
			break;

		case "artist":
			gridItemToClone = wrapper
				? findHtmlEl(wrapper, ".artist-list-item")
				: null;
			break;

		default:
			gridItemToClone = findHtmlEl(".elms-to-clone .card-item");
			break;
	}

	const trendingCategoryItemToClone = findHtmlEl(
		".elms-to-clone .trending-photo-category-list-item",
	);

	const supporterBadgeToClone = findHtmlEl(
		".elms-to-clone .svg-icon-membership-badge.is-supporter",
	);

	const proBadgeToClone = findHtmlEl(
		".elms-to-clone .svg-icon-membership-badge.is-pro",
	);

	const superbackerBadgeToClone = findHtmlEl(
		".elms-to-clone .svg-icon-membership-badge.is-superbacker",
	);

	const loadMoreStartDetector = findHtmlEl(".load-more-threshold");

	/**
	 * Number of pixel (before reaching the bottom) to trigger the load more earlier.
	 */
	const loadMoreEarlierPx =
		(loadMoreStartDetector ? loadMoreStartDetector.clientHeight : 0) + 600;

	let scrollEndReached: boolean = false;

	let currentLoadedPhotoIds: number[] = [];

	let loadedAdsIds: number[] = [];

	const showAds =
		wrapper && wrapper.dataset.showSpc ? wrapper.dataset.showSpc == "1" : false;

	const excludeViewedPhotos =
		wrapper && wrapper.dataset.excludeViewedPhotos
			? wrapper.dataset.excludeViewedPhotos == "1"
			: false;

	if (loadMoreType === "photo" && excludeViewedPhotos) {
		const preloadedPhotos = wrapper
			? findHtmlEls(wrapper, ".grid-image-wrapper")
			: [];

		if (preloadedPhotos.length) {
			for (let pIndex = 0; pIndex < preloadedPhotos.length; pIndex++) {
				const photoIdStr = preloadedPhotos[pIndex].dataset.photoId;
				const photoId = photoIdStr ? parseInt(photoIdStr, 10) : 0;

				if (photoId) currentLoadedPhotoIds.push(photoId);
			}
		}
	}

	if (loadMoreType === "photo" && showAds) {
		const preloadedAds = wrapper
			? findHtmlEls(wrapper, ".grid-item[data-spc-id]")
			: [];

		for (let aIndex = 0; aIndex < preloadedAds.length; aIndex++) {
			const adsIdStr = preloadedAds[aIndex].dataset.spcId;
			const adsId = adsIdStr ? parseInt(adsIdStr, 10) : 0;

			if (adsId) loadedAdsIds.push(adsId);
		}
	}

	window.addEventListener("scroll", checkScrollPosition);

	/**
	 * Set the next page number
	 *
	 * @param number number The next page number.
	 */
	function setNextPageNumber(number: number) {
		nextPageNumber = number;
	}

	function setScrollEndReached(state: boolean) {
		scrollEndReached = state;
	}

	function setLastScrollTop(position: number) {
		lastScrollTop = position;
	}

	function setDoingAjax(state: boolean) {
		doingAjax = state;
	}

	function setSearchKeyword(keyword: string) {
		searchKeyword = keyword;
	}

	function enableExtraSearch() {
		useExtraSearch = true;
	}

	function disableExtraSearch() {
		useExtraSearch = false;
	}

	/**
	 * Check scrolling position.
	 */
	async function checkScrollPosition() {
		if (
			window.scrollY + document.documentElement.clientHeight >
			document.documentElement.scrollHeight - loadMoreEarlierPx - footerHeight
		) {
			await doLoadMore();
		}
	}

	/**
	 * Start the loading indicator.
	 */
	function startLoading() {
		if (!loadingEl) return;
		loadingEl.classList.add("is-loading");
	}

	/**
	 * Stop the loading indicator.
	 */
	function stopLoading() {
		if (!loadingEl) return;
		loadingEl.classList.remove("is-loading");
	}

	/**
	 * Show the wrapper.
	 */
	function showWrapper() {
		if (!wrapper) return;
		wrapper.classList.remove("is-hidden");
	}

	/**
	 * Hide the wrapper.
	 */
	function hideWrapper() {
		if (!wrapper) return;
		wrapper.classList.add("is-hidden");
	}

	/**
	 * Show the empty items notice.
	 */
	function showEmptyNotice() {
		$noItemsNotice.stop().fadeIn(150);
	}

	/**
	 * Hide the empty items notice.
	 */
	function hideEmptyNotice() {
		$noItemsNotice.stop().fadeOut(150);
	}

	/**
	 * Run the load more ajax request.
	 */
	async function doLoadMore() {
		if (!wrapper) return;
		if (doingAjax) return;
		if (scrollEndReached) return;
		if (window.scrollY <= lastScrollTop) return;

		lastScrollTop = window.scrollY;
		doingAjax = true;

		hideEmptyNotice();
		startLoading();

		let postData: FormData = new FormData();

		postData.append("nonce", pm.nonces.loadMore);
		postData.append("action", "pm_load_more_" + loadMoreType + "s");

		currentPageNumber = nextPageNumber;

		if (currentPageNumber > 1 && lastId > 0) {
			postData.append("last_id", lastId.toString());
		}

		if (searchKeyword) {
			postData.append("search_keyword", searchKeyword);

			if (useExtraSearch) {
				postData.append("use_extra_search", "1");
			}

			hideElementsOnSearch();

			if (currentPageNumber === 1) {
				hideElementsDuringSearch();
			}
		} else {
			hideElementsDuringSearch();
		}

		if (wrapper.dataset.postsPerPage) {
			postData.append("posts_per_page", wrapper.dataset.postsPerPage);
		}

		if (wrapper.dataset.includeIds) {
			postData.append("include_ids", wrapper.dataset.includeIds);
		}

		if (wrapper.dataset.excludeIds) {
			postData.append("exclude_ids", wrapper.dataset.excludeIds);
		}

		if (loadMoreType === "photo") {
			if (wrapper.dataset.profileId) {
				postData.append("profile_id", wrapper.dataset.profileId);
			}

			if (wrapper.dataset.postStatus) {
				postData.append("post_status", wrapper.dataset.postStatus);
			}

			if (wrapper.dataset.useCategories) {
				postData.append("use_categories", "1");
			}

			if (wrapper.dataset.categoryId) {
				postData.append("category_id", wrapper.dataset.categoryId);
			}

			if (wrapper.dataset.cameraName) {
				postData.append("camera_name", wrapper.dataset.cameraName);
			}

			if (
				wrapper.hasAttribute("data-album-slug") &&
				wrapper.dataset.albumSlug
			) {
				postData.append("album", wrapper.dataset.albumSlug);
			}

			if (wrapper.dataset.useLikeStatus) {
				postData.append("use_like_status", wrapper.dataset.useLikeStatus);
			}

			if (wrapper.dataset.authorId) {
				postData.append("author_id", wrapper.dataset.authorId);
			}

			if (wrapper.dataset.featured) {
				postData.append("featured", wrapper.dataset.featured);
			}

			const needsFeedback = wrapper.dataset.needsFeedback;

			if (needsFeedback !== undefined) {
				postData.append("needs_feedback", needsFeedback);
			}

			const doneFeedback = wrapper.dataset.doneFeedback;

			if (doneFeedback === "0") {
				postData.append("done_feedback", "0");
			}

			if (wrapper.dataset.excludeViewedPhotos) {
				postData.append("viewed_photo_ids", currentLoadedPhotoIds.join(","));
			}

			if (wrapper.dataset.excludeAuthorIds) {
				postData.append("exclude_author_ids", wrapper.dataset.excludeAuthorIds);
			}

			if (showAds) {
				postData.append("show_ads", "1");
				postData.append("loaded_ads", loadedAdsIds.join(","));
			}
		} else if (loadMoreType === "artist") {
			if (currentPageNumber > 1 && lastTotalPhotos > 0) {
				postData.append("last_total_photos", lastTotalPhotos.toString());
			}

			if (wrapper.dataset.useFollowingStatus) {
				postData.append(
					"use_following_status",
					wrapper.dataset.useFollowingStatus,
				);
			}
		}

		ajaxController = new AbortController();

		const httpResponse = await requestLoadMore({
			ajaxController: ajaxController,
			formData: postData,
		});

		doingAjax = false;
		ajaxController = null;
		stopLoading();

		const loadMoreData = httpResponse.data;

		if (!searchKeyword) {
			showElementsOnSearchClean();
		}

		showWrapper();

		if (!httpResponse.success) {
			return;
		}

		if (currentPageNumber === 1) {
			let isEmpty: boolean = false;

			switch (loadMoreType) {
				case "photo":
					isEmpty = !(loadMoreData && loadMoreData.photos.length);
					break;

				case "artist":
					isEmpty = !(loadMoreData && loadMoreData.artists.length);
					break;

				case "category":
					isEmpty = !(loadMoreData && loadMoreData.categories.length);
					break;

				case "camera":
					isEmpty = !(
						loadMoreData &&
						loadMoreData.cameras &&
						loadMoreData.cameras.length
					);
					break;
			}

			if (isEmpty) {
				showEmptyNotice();
				hideWrapper();
				return;
			}

			pm.utils.dom.emptyElement(wrapper);
		}

		const categories = loadMoreData ? loadMoreData.categories : [];
		const artists = loadMoreData ? loadMoreData.artists : [];
		const photos = loadMoreData ? loadMoreData.photos : [];
		const cameras =
			loadMoreData && loadMoreData.cameras ? loadMoreData.cameras : [];

		let items: PhotoData[] | ArtistData[] | CategoryData[] | CameraData[] = [];

		switch (loadMoreType) {
			case "photo":
				items = photos;
				break;

			case "artist":
				items = artists;
				break;

			case "category":
				items = categories;
				break;

			case "camera":
				items = cameras;
				break;
		}

		const existingCategoryResults = trendingCategoriesResultWrapper
			? findHtmlEls(
					trendingCategoriesResultWrapper,
					".trending-photo-category-list-item",
				)
			: [];

		if (loadMoreType === "photo") {
			if (searchKeyword) {
				if (useExtraSearch) {
					if (
						!categories.length ||
						!trendingCategoriesResultWrapper ||
						!trendingCategoryItemToClone
					) {
						hideElementsDuringSearch();
					} else {
						buildTrendingCategoriesOutput(
							categories,
							trendingCategoriesResultWrapper,
							trendingCategoryItemToClone,
						);

						showElementsAfterSearch();
					}
				} else {
					if (existingCategoryResults.length) {
						showElementsAfterSearch();
					}
				}
			}
		}

		// The scroll reaches the end of items.
		if (!items.length) {
			scrollEndReached = true;
			return;
		}

		const lastItem = items[items.length - 1];

		lastId = lastItem.hasOwnProperty("id") ? lastItem.id : 0;

		if (loadMoreType === "artist") {
			lastTotalPhotos = artists[artists.length - 1].totalPhotos;
		}

		currentLoadedPhotoIds = [];

		if (wrapper && gridItemToClone) {
			items.forEach(function (
				data: PhotoData | ArtistData | CategoryData | CameraData,
			) {
				if (loadMoreType === "photo") {
					const photoData = data as PhotoData;
					currentLoadedPhotoIds.push(photoData.id);

					insertPhotoToGrid({
						photoData: photoData,
						insertMode: "append",
					});

					if (photoData.adId > 0) {
						loadedAdsIds.push(photoData.adId);
					}

					return;
				}

				if (loadMoreType === "artist") {
					buildArtistOutput(data as ArtistData, wrapper, gridItemToClone!);
					return;
				}

				if (loadMoreType === "camera") {
					buildCameraOutput(data as CameraData, wrapper, gridItemToClone!);
					return;
				}
			});
		}

		if (wrapper.classList.contains("flexmasonry")) {
			// This is for the "search" and "tab switch".
			if (currentPageNumber === 1) {
				// Prevent the flickering effect.
				wrapper.style.opacity = "0";

				/**
				 * Wait for few milliseconds until wrapper's display value is flex (with opacity is still 0).
				 * This wait is necessary because we call the `showWrapper()` in `ajaxRequest.always` callback.
				 */
				setTimeout(function () {
					FlexMasonry.refresh(wrapper);

					/**
					 * Wait for few milliseconds more for the FlexMasonry to refresh.
					 * We try to prevent to see the flickering effect.
					 */
					setTimeout(function () {
						wrapper.style.opacity = "1";
					}, 30);
				}, 50);
			} else {
				// Refresh directly. This is for the "load more".
				FlexMasonry.refresh(wrapper);
			}
		}

		jQuery(document).trigger("pm_photos_loaded");

		useExtraSearch = false;

		// The scroll reaches the end of items.
		if (items.length < pm.postsPerPage) {
			scrollEndReached = true;
			return;
		}

		nextPageNumber++;
	}

	function hideElementsDuringSearch() {
		if (!elmsToShowAfterSearch.length) return;

		elmsToShowAfterSearch.forEach(function (el) {
			el.classList.add("is-hidden");
		});
	}

	function showElementsAfterSearch() {
		if (!elmsToShowAfterSearch.length) return;

		elmsToShowAfterSearch.forEach(function (el) {
			el.classList.remove("is-hidden");
		});
	}

	function hideElementsOnSearch() {
		if (!elmsToHideOnSearch.length) return;

		elmsToHideOnSearch.forEach(function (el) {
			el.classList.add("is-hidden");
		});
	}

	function showElementsOnSearchClean() {
		if (!elmsToHideOnSearch.length) return;

		elmsToHideOnSearch.forEach(function (el) {
			if (el.classList.contains("trending-photo-category-list")) {
				if (searchKeyword) {
					el.classList.remove("is-hidden");
				} else {
					el.classList.add("is-hidden");
				}
			} else {
				el.classList.remove("is-hidden");
			}
		});
	}

	async function resetPhotosLoad() {
		nextPageNumber = 1;
		lastId = 0;
		lastTotalPhotos = 0;
		scrollEndReached = false;
		lastScrollTop = -1;
		doingAjax = false;
		loadedAdsIds = [];

		if (ajaxController) {
			ajaxController.abort();
		}

		await doLoadMore();
	}

	function insertPhotoToGrid(props: InsertPhotoToGridProps) {
		if (!wrapper || !gridItemToClone) return;

		buildPhotoOutput(
			props.photoData,
			wrapper,
			gridItemToClone,
			supporterBadgeToClone,
			proBadgeToClone,
			superbackerBadgeToClone,
			props.insertMode,
		);
	}

	function getTotalPhotos(): number {
		if (!wrapper) return 0;
		return findHtmlEls(wrapper, ".grid-item").length;
	}

	function refreshGrid() {
		if (!wrapper) return;
		FlexMasonry.refresh(wrapper);
	}

	return {
		setNextPageNumber: setNextPageNumber,
		setScrollEndReached: setScrollEndReached,
		setLastScrollTop: setLastScrollTop,
		setDoingAjax: setDoingAjax,
		ajaxController: ajaxController,
		doLoadMore: doLoadMore,
		showEmptyNotice: showEmptyNotice,
		hideEmptyNotice: hideEmptyNotice,
		resetPhotosLoad: resetPhotosLoad,
		setSearchKeyword: setSearchKeyword,
		enableExtraSearch: enableExtraSearch,
		disableExtraSearch: disableExtraSearch,
		insertPhotoToGrid: insertPhotoToGrid,
		getTotalPhotos: getTotalPhotos,
		refreshGrid: refreshGrid,
	};
})();
